import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import InfoCard from "@components/core/cards/InfoCard";
import parse from "html-react-parser";
import { Swiper, SwiperSlide } from "swiper/react";
import { SwiperOptions } from "swiper/types";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import { ArticleDetailResponseDto } from "@state/cms/dto/response/article.detail.response.dto";

interface CarouselCardProps {
  articles: ArticleDetailResponseDto[];
  className?: string;
}

const CarouselCard: FunctionComponent<CarouselCardProps> = ({
  articles,
  className = "",
}) => {
  const { t } = useTranslation();
  const params: SwiperOptions = {
    direction: "vertical",
    centeredSlides: true,
    slidesPerView: 1,
    autoplay: {
      delay: 15000,
      disableOnInteraction: false,
    },
    loop: articles && articles.length > 1,
    pagination:
      articles && articles.length > 1
        ? {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
          }
        : false,
  };
  if (articles && articles.length > 0) {
    return (
      <div className={`app-carousel-card ${className}`}>
        <Swiper {...params} modules={[Autoplay, Pagination]}>
          {articles.map((article) => (
            <SwiperSlide key={`${article.name}_${article.id}`}>
              {article.isNew && (
                <div className="offer-custom z-1000">
                  <div className="shape">
                    <div className="shape-text">{t("home.new")}</div>
                  </div>
                </div>
              )}
              {article.content && (
                <div className="article-content">{parse(article.content)}</div>
              )}
            </SwiperSlide>
          ))}
          <div className="swiper-pagination" />
        </Swiper>
      </div>
    );
  }
  return <InfoCard background="secondary" className={className} />;
};

export default CarouselCard;
